<template>
  <div class="f_content">
    <div class="Onboard-New-Employee">
      <div>
        <div class="Onboard-New-Employee-left">Employees</div>
        <div class="Onboard-New-Employee-right">
          <div class="search">
            <input
              type="text"
              placeholder="Search "
              v-model="searchValue"
              v-on:keyup.enter="getSearchresult"
            />
            <div>
              <img src="./../../../assets/images/search.svg" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="onboard__nav">
      <div
        @click="showEmployee('all')"
        :style="[
          showEmployees.all
            ? { borderBottom: '5px solid #5099de' }
            : { borderBottom: '0' },
        ]"
      >
        All
      </div>
      <div
        @click="showEmployee('active')"
        :style="[
          showEmployees.active
            ? { borderBottom: '5px solid #5099de' }
            : { borderBottom: '0' },
        ]"
      >
        Active
      </div>
      <div
        @click="showEmployee('inactive')"
        :style="[
          showEmployees.inactive
            ? { borderBottom: '5px solid #5099de' }
            : { borderBottom: '0' },
        ]"
      >
        Inactive
      </div>
    </div>

    <div class="container" v-if="showEmployees.all">
      <div class="row main-row">
        <div class="col-md-8 pl-0 left-column page-loader" v-show="pageLoading">
          <div>
            <PageLoader />
          </div>
        </div>

        <div class="col-md-8 pl-0 left-column" v-show="!pageLoading">
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="dataFetchError"
          >
            <font-awesome-icon icon="times-circle" />
            <p>This page did not load successfully. Please try again.</p>
          </div>

          <div
            class="alert d-flex align-items-center"
            role="alert"
            v-if="noData"
          >
            <font-awesome-icon icon="times-circle" />
            <p class="f_font">There are no employees in the system yet.</p>
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="dataSaveError"
          >
            <font-awesome-icon icon="times-circle" />
            <p>Unable to process your request. Please try again.</p>
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="serverErrors"
          >
            <font-awesome-icon icon="times-circle" />
            <p v-for="(value, name, index) in serverErrors" :key="index">
              {{ value[0] }}
            </p>
          </div>

          <div
            class="alert alert-success d-flex align-items-center"
            role="alert"
            v-if="hireWithhrdesk"
          >
            <font-awesome-icon icon="check-circle" />
            {{ hireWithhrdesk }}
          </div>

          <div v-if="searchReturned" class="mb-5">
            Viewing search results for
            <b>{{ searchValue }}</b
            >.
            <a class="action" @click.prevent="getEmployees()">View all</a>
            employees instead.
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="searchMessage"
          >
            <font-awesome-icon icon="times-circle" />
            <p>No result found.</p>
          </div>

          <div
            class="card"
            v-for="(employee, index) in employees"
            :key="index"
            @click.prevent="viewEmployee(employee)"
          >
            <div
              class="invite-container"
              v-show="!employee.user.email_verified_at"
            >
              <div @click.stop="sendInvite(employee)" class="invite-link">
                <p v-if="!employee.loadingInvite">Resend invite email</p>
                <span class="loader-div" v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div v-if="employee.feedbackMessage" class="response-message">
              <p>{{ employee.feedbackMessage }}</p>
            </div>
            <div v-if="employee.feedbackError" class="error-message">
              <p>{{ employee.feedbackError }}</p>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  <img
                    src="./../../../assets/style/images/boy.svg"
                    class
                    alt="passport"
                  />
                  <div>
                    <p class="name">
                      {{ employee.user.firstname }}
                      <strong>{{ employee.user.lastname }}</strong>
                    </p>

                    <div class="status">
                      <p v-if="employee.user.is_active">active</p>
                      <p v-else>deactivated</p>
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                  <p class="jobtitle">
                    {{
                      employee.designations ? employee.designations.name : ""
                    }}
                  </p>
                </div>
                <div class="col-2 d-flex align-items-center">
                  <div>
                    <span>{{ employee.role_name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="paginationContainer">
              <div class="pagination-controls">
                <button
                  class="paginationBtn"
                  @click="prevPage"
                  :disabled="!pagination.prev_page_url"
                >
                  Previous
                </button>
                <span
                  >Page {{ pagination.current_page }} of
                  {{ pagination.last_page }}</span
                >

                <button
                  class="paginationBtn"
                  @click="nextPage"
                  :disabled="!pagination.next_page_url"
                >
                  Next
                </button>
              </div>
            </div>
        </div>

        <div class="col-md-4 right-column" v-if="manager !== 1">
          <div class="job_link">
            <div>
              <p class="form-text-link" @click="showCompanySetting">
                <font-awesome-icon icon="plus-circle" />
                Create a
                <span class="form-text-span"> job title </span>
              </p>
            </div>
          </div>
          <div class="onboard-button">
            <router-link name id to="/onboardemployee" role="button">
              <div>
                <font-awesome-icon icon="plus-circle" />Onboard New Employees
              </div>
            </router-link>
          </div>
          <div class="info-card">
            <p class="text-center">Planning to hire anytime soon?</p>
            <img
              class="handshake"
              src="./../../../assets/style/images/handshake.svg"
              alt="handshake"
            />
            <p class="text-center">
              hrdesk can help you hire for
              <br />any positions you want to fill.
            </p>
            <routerLink to="/hire">
              <div class="onboard">Hire with hrdesk</div>
            </routerLink>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="showEmployees.active">
      <div class="row main-row">
        <div class="col-md-8 pl-0 left-column page-loader" v-show="pageLoading">
          <div>
            <PageLoader />
          </div>
        </div>

        <div class="col-md-8 pl-0 left-column" v-show="!pageLoading">
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="dataFetchError"
          >
            <font-awesome-icon icon="times-circle" />
            <p>This page did not load successfully. Please try again.</p>
          </div>

          <div
            class="alert d-flex align-items-center"
            role="alert"
            v-if="noData"
          >
            <font-awesome-icon icon="times-circle" />
            <p class="f_font">There are no employees in the system yet.</p>
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="dataSaveError"
          >
            <font-awesome-icon icon="times-circle" />
            <p>Unable to process your request. Please try again.</p>
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="serverErrors"
          >
            <font-awesome-icon icon="times-circle" />
            <p v-for="(value, name, index) in serverErrors" :key="index">
              {{ value[0] }}
            </p>
          </div>

          <div
            class="alert alert-success d-flex align-items-center"
            role="alert"
            v-if="hireWithhrdesk"
          >
            <font-awesome-icon icon="check-circle" />
            {{ hireWithhrdesk }}
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="searchMessage"
          >
            <font-awesome-icon icon="times-circle" />
            <p>No result found.</p>
          </div>

          <div
            class="card"
            v-for="(employee, index) in employees"
            :key="index"
            @click.prevent="viewEmployee(employee)"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  <img
                    src="./../../../assets/style/images/boy.svg"
                    class
                    alt="passport"
                  />
                  <div>
                    <p class="name">
                      {{ employee.user.firstname }}
                      <strong>{{ employee.user.lastname }}</strong>
                    </p>

                    <div class="status">
                      <p v-if="employee.user.is_active">active</p>
                      <p v-else>deactivated</p>
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                  <p class="jobtitle">
                    {{
                      employee.designations ? employee.designations.name : ""
                    }}
                  </p>
                </div>
                <div class="col-2 d-flex align-items-center">
                  <span>{{ employee.role_name }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="payroll__breakdown--paginate"
            v-if="employees.length !== 0"
          >
            <div @click="paginatePage(pages.first_page_url)">1</div>
            <div @click="paginatePage(pages.prev_page_url)">prev</div>
            <div>{{ pages.current_page }}</div>
            <div @click="paginatePage(pages.next_page_url)">next</div>
            <div @click="paginatePage(pages.last_page_url)">
              {{ pages.last_page }}
            </div>
          </div>
        </div>

        <div class="col-md-4 pr-0 right-column" v-if="manager !== 1">
          <div class="onboard-button">
            <router-link name id to="/onboardemployee" role="button">
              <div>
                <font-awesome-icon icon="plus-circle" />Onboard New Employees
              </div>
            </router-link>
          </div>
          <div class="info-card">
            <p class="text-center">Planning to hire anytime soon?</p>
            <img
              class="handshake"
              src="./../../../assets/style/images/handshake.svg"
              alt="handshake"
            />
            <p class="text-center">
              hrdesk can help you hire for
              <br />any positions you want to fill.
            </p>
            <div
              class="onboard"
              @click.prevent="sendInquiry()"
              v-if="!sendingInquiry"
            >
              Hire with hrdesk
            </div>
            <div v-else>
              <BlueLoader />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="showEmployees.inactive">
      <div class="row main-row">
        <div class="col-md-8 pl-0 left-column page-loader" v-show="pageLoading">
          <div>
            <PageLoader />
          </div>
        </div>

        <div class="col-md-8 pl-0 left-column" v-show="!pageLoading">
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="dataFetchError"
          >
            <font-awesome-icon icon="times-circle" />
            <p>This page did not load successfully. Please try again.</p>
          </div>

          <div
            class="alert d-flex align-items-center"
            role="alert"
            v-if="noData"
          >
            <font-awesome-icon icon="times-circle" />
            <p class="f_font">There are no employees in the system yet.</p>
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="dataSaveError"
          >
            <font-awesome-icon icon="times-circle" />
            <p>Unable to process your request. Please try again.</p>
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="serverErrors"
          >
            <font-awesome-icon icon="times-circle" />
            <p v-for="(value, name, index) in serverErrors" :key="index">
              {{ value[0] }}
            </p>
          </div>

          <div
            class="alert alert-success d-flex align-items-center"
            role="alert"
            v-if="hireWithhrdesk"
          >
            <font-awesome-icon icon="check-circle" />
            {{ hireWithhrdesk }}
          </div>

          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            v-if="searchMessage"
          >
            <font-awesome-icon icon="times-circle" />
            <p>No result found.</p>
          </div>

          <div
            class="card"
            v-for="(employee, index) in employees"
            :key="index"
            @click.prevent="viewEmployee(employee)"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  <img
                    src="./../../../assets/style/images/boy.svg"
                    class
                    alt="passport"
                  />
                  <div>
                    <p class="name">
                      {{ employee.user.firstname }}
                      <strong>{{ employee.user.lastname }}</strong>
                    </p>

                    <div class="status">
                      <p v-if="employee.user.is_active">active</p>
                      <p v-else>deactivated</p>
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                  <p class="jobtitle">
                    {{
                      employee.designations ? employee.designations.name : ""
                    }}
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <span>{{ employee.role_name }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="paginationContainer">
              <div class="pagination-controls">
                <button
                  class="paginationBtn"
                  @click="prevPage"
                  :disabled="!pagination.prev_page_url"
                >
                  Previous
                </button>
                <span
                  >Page {{ pagination.current_page }} of
                  {{ pagination.last_page }}</span
                >

                <button
                  class="paginationBtn"
                  @click="nextPage"
                  :disabled="!pagination.next_page_url"
                >
                  Next
                </button>
              </div>
            </div>
        </div>

        <div class="col-md-4 pr-0 right-column" v-if="manager !== 1">
          <div class="onboard-button">
            <router-link name id to="/onboardemployee" role="button">
              <div>
                <font-awesome-icon icon="plus-circle" />Onboard New Employees
              </div>
            </router-link>
          </div>
          <div class="info-card">
            <p class="text-center">Planning to hire anytime soon?</p>
            <img
              class="handshake"
              src="./../../../assets/style/images/handshake.svg"
              alt="handshake"
            />
            <p class="text-center">
              hrdesk can help you hire for
              <br />any positions you want to fill.
            </p>
            <div
              class="onboard"
              @click.prevent="sendInquiry()"
              v-if="!sendingInquiry"
            >
              Hire with hrdesk
            </div>
            <div v-else>
              <BlueLoader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import BlueLoader from "../../partials/blue-loader";

export default {
  name: "Batchupload",
  components: {
    PageLoader,
    BlueLoader,
  },
  data() {
    return {
      employees: [],
      pageLoading: true,
      searchValue: "",
      dataFetchError: false,
      searchMessage: false,
      hireWithhrdesk: "",
      dataSaveError: "",
      serverErrors: null,
      searchReturned: false,
      sendingInquiry: false,
      noData: false,
      pages: {},
      currentPath: {
        method: "",
        url: "",
      },
      showEmployees: {
        all: true,
        active: false,
        inactive: false,
      },
      manager: 1,
      paginatedData: [],
      pagination: {
        current_page: null,
        last_page: null,
        next_page_url: null,
        prev_page_url: null,
        itemsPerPage: null,
        totalRecords: null,
        total_page: null,
      },
    };
  },

  created() {
    this.getManagerLevel();
    this.getEmployees();
    this.fetchData();
  },

  mounted() {
    if (this.$store.showInactiveEmployee) {
      this.showEmployee("inactive");
      this.$store.showInactiveEmployee = "";
    }
    this.initializeFeedbackMessages();
  },

  computed: {
    totalPages() {
      return Math.ceil(
        this.pagination.totalRecords / this.pagination.itemsPerPage
      );
    },
  },

  methods: {
    fetchData(page = 1) {
      const url = `${types.GET_EMPLOYEES_API}?page=${page}`;
      this.$http
        .get(url)
        .then((resp) => {
          this.history = resp.data.data.data;
          let data = resp.data.data;
          this.paginatedData = data.data;

          this.pagination = {
            current_page: data.current_page,
            last_page: data.last_page,
            next_page:
              data.current_page < data.last_page ? data.current_page + 1 : null,
            prev_page: data.current_page > 1 ? data.current_page - 1 : null,
            items_per_page: data.per_page,
            total_records: data.total,
          };    
          this.loader = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.pagination.next_page_url) {
        this.fetchData(this.pagination.next_page_url);
      }
    },
    prevPage() {
      if (this.pagination.prev_page_url) {
        this.fetchData(this.pagination.prev_page_url);
      }
    },
    initializeFeedbackMessages() {
      this.employees = this.employees.map((employee) => {
        return {
          ...employee,
          feedbackMessage: "",
          feedbackError: "",
          loadingInvite: false,
        };
      });
    },
    sendInvite(employee) {
      const uuid = employee.uuid;
      this.$set(employee, "feedbackMessage", "");
      this.$set(employee, "feedbackError", "");
      this.$set(employee, "loadingInvite", true);

      this.$http
        .post(`${types.SEND_INVITE_LINK}/${uuid}`)
        .then((resp) => {
          if (resp.data.status === true) {
            this.$set(employee, "feedbackMessage", "Invite sent successfully!");
            this.$set(employee, "loadingInvite", false);
            setTimeout(() => {
              this.$set(employee, "feedbackMessage", "");
            }, 5000);
          }
          this.loadingInvite = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (resp.data.status === !true) {
            this.$set(employee, "feedbackError", "Failed to send invite");
            this.$set(employee, "loadingInvite", false);
            setTimeout(() => {
              this.$set(employee, "feedbackError", "");
            }, 5000);
          }
          loadingInvite;
        });
      event.stopPropagation();
    },
    showCompanySetting() {
      window.open("/settings?sec=company#company", "_blank");
    },
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId =
          this.$store.getters.currentAuthUser.employees.company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then((resp) => {
          this.$store.state.managedClient = resp.data.data.managed;
          this.manager = this.$store.state.managedClient;
        });
      } else {
        this.manager = this.$store.state.managedClient;
      }
    },
    showEmployee(val) {
      if (val === "all") {
        this.showEmployees = {
          all: true,
          active: false,
          inactive: false,
        };
        this.getEmployees();
      }
      if (val === "active") {
        this.showEmployees = {
          all: false,
          active: true,
          inactive: false,
        };
        this.getEmployeesActive();
      }
      if (val === "inactive") {
        this.showEmployees = {
          all: false,
          active: false,
          inactive: true,
        };
        this.getEmployeesInactive();
      }
    },
    formatDate(dateValue) {
      if (dateValue) {
        const date = new Date(dateValue);
        return date.toLocaleString().split(", ")[0];
      }
    },
    paginatePage(val) {
      if (val) {
        if (val !== this.currentPath.url) {
          this.pageLoading = true;
          this.employees = [];
          this.searchValue = "";
          this.noData = false;
          this.searchReturned = false;
          this.searchMessage = false;
          this.dataFetchError = false;

          if (this.currentPath.method === "get") {
            this.$http
              .get(val)
              .then((resp) => {
                this.pages = {
                  first_page_url: resp.data.data.first_page_url,
                  prev_page_url: resp.data.data.prev_page_url,
                  current_page: resp.data.data.current_page,
                  next_page_url: resp.data.data.next_page_url,
                  last_page_url: resp.data.data.last_page_url,
                  last_page: resp.data.data.last_page,
                };

                this.currentPath.url = val;

                this.pageLoading = false;
                this.employees = resp.data.data.data;
                if (this.employees.length) {
                  this.pagination = resp.data;
                  return;
                }
                this.noData = true;
              })
              .catch((err) => {
                this.pageLoading = false;
                if (err.response) {
                  this.dataFetchError = true;
                }
              });
          }

          if (this.currentPath.method === "post") {
            this.$http
              .post(val)
              .then((resp) => {
                this.pages = {
                  first_page_url: resp.data.data.first_page_url,
                  prev_page_url: resp.data.data.prev_page_url,
                  current_page: resp.data.data.current_page,
                  next_page_url: resp.data.data.next_page_url,
                  last_page_url: resp.data.data.last_page_url,
                  last_page: resp.data.data.last_page,
                };

                this.currentPath.url = val;

                this.pageLoading = false;
                this.employees = resp.data.data.data;
                if (this.employees.length) {
                  this.pagination = resp.data;
                  return;
                }
                this.noData = true;
              })
              .catch((err) => {
                this.pageLoading = false;
                if (err.response) {
                  this.dataFetchError = true;
                }
              });
          }
        }
      }
    },
    getEmployees() {
      this.searchValue = "";
      this.noData = false;
      this.searchReturned = false;
      this.searchMessage = false;
      this.employees = [];
      this.pageLoading = true;
      this.dataFetchError = false;

      this.$http
        .get(types.GET_EMPLOYEES_API)
        .then((resp) => {
          this.pages = {
            first_page_url: resp.data.data.first_page_url,
            prev_page_url: resp.data.data.prev_page_url,
            current_page: resp.data.data.current_page,
            next_page_url: resp.data.data.next_page_url,
            last_page_url: resp.data.data.last_page_url,
            last_page: resp.data.data.last_page,
          };

          this.currentPage = resp.data.data.current_page;
          this.totalRecords = resp.data.data.total;

          this.currentPath.method = "get";
          this.currentPath.url = this.pages.first_page_url;

          this.pageLoading = false;
          this.employees = resp.data.data.data;

          if (this.employees.length) {
            this.pagination = resp.data;
            return;
          }
          this.noData = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    getEmployeesActive() {
      this.searchValue = "";
      this.noData = false;
      this.searchReturned = false;
      this.searchMessage = false;
      this.employees = [];
      this.pageLoading = true;
      this.dataFetchError = false;

      this.$http
        .post(types.GET_EMPLOYEES_FILTER_API, { status: 1 })
        .then((resp) => {
          this.pages = {
            first_page_url: resp.data.data.first_page_url,
            prev_page_url: resp.data.data.prev_page_url,
            current_page: resp.data.data.current_page,
            next_page_url: resp.data.data.next_page_url,
            last_page_url: resp.data.data.last_page_url,
            last_page: resp.data.data.last_page,
          };
          // this.currentPath = this.pages.first_page_url;

          this.currentPath.method = "post";
          this.currentPath.url = this.pages.first_page_url;

          this.pageLoading = false;
          this.employees = resp.data.data.data;
          if (this.employees.length) {
            this.pagination = resp.data;
            return;
          }
          this.noData = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    getEmployeesInactive() {
      this.searchValue = "";
      this.noData = false;
      this.searchReturned = false;
      this.searchMessage = false;
      this.employees = [];
      this.pageLoading = true;
      this.dataFetchError = false;

      this.$http
        .post(types.GET_EMPLOYEES_FILTER_API, { status: 0 })
        .then((resp) => {
          this.pages = {
            first_page_url: resp.data.data.first_page_url,
            prev_page_url: resp.data.data.prev_page_url,
            current_page: resp.data.data.current_page,
            next_page_url: resp.data.data.next_page_url,
            last_page_url: resp.data.data.last_page_url,
            last_page: resp.data.data.last_page,
          };
          // this.currentPath = this.pages.first_page_url;
          this.currentPath.method = "post";
          this.currentPath.url = this.pages.first_page_url;

          this.pageLoading = false;
          this.employees = resp.data.data.data;
          if (this.employees.length) {
            this.pagination = resp.data;
            return;
          }
          this.noData = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    viewEmployee(employee) {
      this.$router.push({
        name: "viewEmployee",
        params: { id: employee.uuid },
      });
    },
    getSearchresult() {
      this.pageLoading = true;

      if (this.searchValue) {
        this.showEmployees = {
          all: true,
          active: false,
          inactive: false,
        };
        this.$http
          .post(types.USER_SEARCH_API, {
            key: this.searchValue,
          })
          .then((resp) => {
            this.employees = resp.data.data.data;
            this.pageLoading = false;
            this.searchReturned = true;
            if (this.employees.length === 0) {
              this.searchMessage = true;
              return;
            }
            this.searchMessage = false;
          })
          .catch(() => {
            this.pageLoading = false;
            this.searchMessage = false;
          });
      }
    },
    sendInquiry() {
      this.hireWithhrdesk = "";
      this.dataSaveError = "";
      this.serverErrors = null;

      this.sendingInquiry = true;

      this.$http
        .get(types.INQUIRY_API)
        .then(() => {
          this.hireWithhrdesk =
            "A notification has been set. You will be contacted shortly.";
          this.sendingInquiry = false;
        })
        .catch((err) => {
          this.sendingInquiry = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.paginationContainer {
  margin-top: 20px;
}
.pagination-controls {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0 auto;
  background: rgb(217, 216, 216);
  margin: 0 auto;
  text-align: center;
  width: 20rem;
}
.paginationBtn {
  padding: 5px 10px;
  background: #fff;
  border-radius: 4px;
}
.loader-div {
  display: inline-block;
}

.loader-div svg {
  animation: spin 1s linear infinite;
  width: 1rem;
  height: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.response-message {
  text-align: center;
  font-size: 0.8rem;
  color: #0767c1;
  font-style: italic;
  background: #fbfafa;
}
.error-message {
  text-align: center;
  font-size: 0.8rem;
  color: crimson;
  font-style: italic;
  background: #fbfafa;
}
.invite-container {
  position: absolute;
  bottom: 0.5rem;
  right: 1.5rem;
  z-index: 10;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.2rem;
  padding-top: 0.2rem;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 8rem;
  background: #f8f6f6;
}

.invite-link {
  font-size: 0.8rem;
  color: #0767c1;
  display: flex;
  margin: 0 auto;
  .span {
    width: 1rem;
  }
}

.job_link {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  background: #fff;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  div {
    color: #0767c1;
    text-align: center;
    word-wrap: break-word;
  }
}

.f_content {
  padding-bottom: 31.5px;
  padding-top: 35px;
  padding-left: 3rem;
  padding-right: 3rem;

  @media (max-width: 768px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  p {
    margin-bottom: 0;
  }

  .alert {
    svg {
      margin-right: 7px;
    }
  }

  .action {
    color: blue;
    text-transform: underline;
    cursor: pointer;
  }

  .error-card {
    background-color: inherit;
  }

  .f_font {
    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }

  .container {
    padding: 0;
    .main-row {
      margin-top: 50px;
      margin-left: auto;
      margin-right: auto;

      .right-column {
        // padding-left: 130px;
        > .onboard-button {
          text-align: center;
          border: none;
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          background-color: #5099de !important;
          font-size: 13px;
          line-height: 1.22;
          letter-spacing: normal;
          color: #ffffff;
          margin-bottom: 20px;

          > a {
            color: #fff;
            text-decoration: none;

            > div {
              width: 100%;
              padding: 15px 0;
            }
          }
        }

        .onboard {
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          background-color: #5099de !important;
          padding: 15px 0;
          font-size: 1rem;
          line-height: 1.22;
          letter-spacing: normal;
          color: #ffffff;
          text-align: center;

          svg {
            margin-right: 6px;
          }
        }

        .info-card {
          height: 25rem;
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
          padding: 8px;
          // margin-top: 40px;

          .handshake {
            display: block;
            width: 6rem;
            height: 4rem;
            margin-bottom: 32px;
            margin: auto;
          }
          p:first-child {
            height: 65.6px;
            font-family: Nunito;
            font-size: 1rem;
            font-weight: 500;
            line-height: 1.55;
            text-align: center;
            color: #000000;
            margin-top: 17px;
            margin-bottom: 17px;
          }
          p:last-of-type {
            height: 45.6px;
            font-family: Nunito;
            font-size: 0.877rem;
            font-weight: 200;
            line-height: 1.73;
            text-align: center;
            color: #707070;
            margin-top: 29px;
            margin-bottom: 25px;
          }

          > a {
            text-decoration: none;
          }

          .onboard {
            width: 150px;
            padding: 15px 0;
            border-radius: 5px;
            font-size: 0.777rem;
            display: block;
            cursor: pointer;
            margin: 0 auto;
          }
        }
      }

      .left-column {
        > .card {
          margin-bottom: 2rem;
          border-radius: 2px;
          border: none;
          position: relative;
          .card-body {
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
            cursor: pointer;

            .row {
              margin: auto;
              span {
                text-align: center;
                border-radius: 15px;
                font-size: 0.8rem;
                display: flex;
                justify-content: center;
                align-items: center;
                border: solid 1px #ffe7bd;
                background-color: #fff9f0;
                padding-left: 1.7rem;
                padding-right: 1.7rem;
                padding-top: 0.3rem;
                padding-bottom: 0.3rem;

                @media (max-width: 768px) {
                }
              }
              .status {
                p {
                  font-size: 1rem;
                  color: #707070;
                }
              }
              .name {
                text-transform: capitalize;
                color: #000;
              }
            }
            .jobtitle {
              font-family: Nunito;
              font-size: 0.8rem;
              font-weight: 200;
              color: #707070;
            }
            p {
              margin: 0;
              width: auto;
            }
            img {
              margin-right: 1.2rem;
              width: 5rem;
              height: 4rem;
              border-radius: 50px;
              background-color: #ffe7bd;
              padding: 0.6rem;
            }
          }
        }
      }
    }
  }

  .error {
    width: 555px;
    margin-top: 10px;
    text-align: center;
    color: red;
    font-size: 0.938vw;
    font-style: italic;
    p {
      margin: 0;
    }
    p::first-letter {
      text-transform: uppercase;
    }
    > div {
      padding-bottom: 10px;
    }
  }

  .page-loader {
    margin-top: 20px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .Onboard-New-Employee {
    overflow: hidden;
    padding-bottom: 10px;

    > div {
      overflow: hidden;
      padding: 3px 0;

      > .Onboard-New-Employee-left {
        width: 30rem;
        float: left;
        font-size: 1.5rem;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin: 0;
        @media (max-width: 768px) {
          float: none;
          padding-bottom: 0.5rem;
        }
      }

      > .Onboard-New-Employee-right {
        width: 214.3px;
        float: right;
        @media (max-width: 768px) {
          float: none;
          padding-bottom: 1rem;
        }
      }
    }
  }

  .onboard__nav {
    border-bottom: 2px solid #ebe4e4;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    align-content: center;

    > div {
      width: 90px;
      height: 30px;
      text-align: center;
      cursor: pointer;
      color: #000;
    }
  }
}

.search {
  max-width: 20rem;
  height: 35px;
  overflow: hidden;
  border: solid 1px #caced5;
  background-color: #ffffff;
  position: relative;

  > input {
    height: 35px;
    font-size: 1rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    border: none;
    outline: none;
    padding-left: 50px;
    padding-right: 5px;

    @media (max-width: 1400px) {
      padding-left: 35px;
    }

    @media (max-width: 768px) {
    }
  }

  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 50px;
    text-align: center;
    padding-top: 5px;

    > img {
      width: 20px;
      height: 20px;
    }
  }
}

.payroll__breakdown--paginate {
  width: 15rem;
  margin: 3rem auto 1rem auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border-radius: 4px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #d7dae2;
  background-color: #ffffff;

  @media (max-width: 768px) {
    width: 12rem;
  }

  > div {
    width: 20%;
    padding: 8px 0;
    text-align: center;
    font-size: 13px;
    border: solid 1px #d7dae2;
    background-color: #ffffff;
    cursor: pointer;
    color: #000;
  }

  > div:nth-child(3) {
    color: #000000;
    background-color: #ddd;
    cursor: pointer;
  }
}
</style>
